export function StreamlineSharpMagnifyingGlassSolid(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      {}
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3.25 11a7.75 7.75 0 1 1 15.5 0a7.75 7.75 0 0 1-15.5 0M11 .75C5.34.75.75 5.34.75 11S5.34 21.25 11 21.25c2.38 0 4.57-.811 6.31-2.172l3.806 3.806l1.768-1.768l-3.806-3.806A10.2 10.2 0 0 0 21.25 11C21.25 5.34 16.661.75 11 .75"
        clipRule="evenodd"
      />
    </svg>
  );
}
